<template>
    <Dialog :visible="visible" modal :header="createUpdateGroup" :style="{ width: '100rem' }" @update:visible="toggleVisibility">
        <Accordion v-model:activeIndex="activeIndex">
            <AccordionTab header="Procedure" :disabled="!multiStepConfig">
                <div class="field grid">
                    <div class="col-3 mt-2">
                        <RadioButton v-model="procedure" inputId="sex" value="sex" @click="onNoAdditionalParameters"/>
                        <label for="sex" class="ml-2" @click="procedure = 'sex'" style="cursor: pointer">Sex</label>
                    </div>
                    <div class="col-9 mt-2">
                        Read from the embedded User Profile data, the declared sex and group by sex
                    </div>
                    <div class="col-3 mt-2">
                        <RadioButton v-model="procedure" inputId="age_today_range" value="age_today_range" @click="onAgeTodayRange"/>
                        <label for="age_today_range" class="ml-2" @click="onAgeTodayRange" style="cursor: pointer">Today age range</label>
                    </div>
                    <div class="col-9 mt-2">
                        Group by the calculated age as today of the user
                    </div>
                    <div class="col-3 mt-2">
                        <RadioButton v-model="procedure" inputId="age_assessment_range" value="age_assessment_range" @click="onAgeAssessmentRange"/>
                        <label for="age_assessment_range" class="ml-2" @click="onAgeAssessmentRange" style="cursor: pointer">Assessment date age range</label>
                    </div>
                    <div class="col-9 mt-2">
                        Group by the calculated age at assessment time of the user
                    </div>
                    <div class="col-3 mt-2">
                        <RadioButton v-model="procedure" inputId="pass_fail" value="pass_fail" @click="onNoAdditionalParameters"/>
                        <label for="pass_fail" class="ml-2" @click="procedure = 'pass_fail'" style="cursor: pointer">Pass / fail</label>
                    </div>
                    <div class="col-9 mt-2">
                        Group by pass / fail
                    </div>
                    <div class="col-3 mt-2">
                        <RadioButton v-model="procedure" inputId="users" value="users" @click="onUser"/>
                        <label for="users" class="ml-2" @click="onUser" style="cursor: pointer">Users</label>
                    </div>
                    <div class="col-9 mt-2">
                        Group by users that submit the assessment
                    </div>
                    <div class="col-3 mt-2">
                        <RadioButton v-model="procedure" inputId="calendar" value="calendar" @click="onCalendar" />
                        <label for="calendar" class="ml-2" @click="procedure = 'calendar'" style="cursor: pointer">Calendar</label>
                    </div>
                    <div class="col-9 mt-2">
                        Group by defined periods of time (years, months, weeks or days)
                    </div>
                    <div class="col-3 mt-2" v-if="props.sharable === 1">
                        <!-- props.sharable === 1 -->
                        <RadioButton v-model="procedure" inputId="companies" value="companies" @click="onNoAdditionalParameters"/>
                        <label for="companies" class="ml-2" @click="procedure = 'companies'" style="cursor: pointer">Companies</label>
                    </div>
                    <div class="col-9 mt-2" v-if="props.sharable === 1">
                        Group by the Company pool linked with the Company
                    </div>
                    <div class="col-3 mt-2">
                        <RadioButton v-model="procedure" inputId="values" value="values" @click="onNoAdditionalParameters"/>
                        <label for="values" class="ml-2" @click="procedure = 'values'" style="cursor: pointer">Value</label>
                    </div>
                    <div class="col-9 mt-2">
                        Group by the value used
                    </div>

                    <div class="col-12 mt-2" v-if="multiStepConfig">
                        <div class="flex justify-content-end">
                            <Button label="Next" icon="pi pi-arrow-circle-right" class="ml-2 p-button-success" @click="onNext" />
                        </div>
                    </div>
                </div>

            </AccordionTab>
            <AccordionTab :header="configurationName" :disabled="!procedureChosen" v-if="multiStepConfig">
                <div class="grid">
                    <template v-if="procedure === 'age_today_range'" class="col-12 mt-3">
                        <div class="col-3 mt-3">
                            <div class="field grid">
                                <div class="col-12 form-field">
                                    <label for="first">Age range</label>
                                    <InputText maxlength = "255" id="first" v-model="first" class="flex-auto" autocomplete="off"  placeholder="Enter the age range"/>
                                </div>
                            </div>
                        </div>
                        <div class="col-9 my-3">
                            The current age of the user (regardless of how old they were when they recorded the assessment) will be used to create groups.<br />
                            This option dictate the numbers of years used for each step.
                            The intervals will be evenly distributed. Default value: <b>10</b><br /><br />
                            <b>Example:</b><br />
                            Age range: <b>7</b><br />
                            Intervals created:<br />
                            &nbsp;0 - &nbsp;6<br />
                            &nbsp;7 - 13<br />
                            14 - 20<br />
                            21 - 27<br />
                            ... and so on.
                        </div>
                    </template>
                    <template v-else-if="procedure === 'age_assessment_range'" class="col-12 mt-3">
                        <div class="col-3 mt-3">
                            <div class="field grid">
                                <div class="col-12 form-field">
                                    <label for="first">Age range</label>
                                    <InputText maxlength = "255" id="first" v-model="first" class="flex-auto" autocomplete="off"  placeholder="Enter the age range"/>
                                </div>
                            </div>
                        </div>
                        <div class="col-9 my-3">
                            The age at the moment of the assessment will be used (regardless how old they are now).<br />
                            This option dictate the numbers of years used for each step.
                            The intervals will be evenly distributed. Default value: <b>10</b><br /><br />
                            <b>Example:</b><br />
                            Age range: <b>7</b><br />
                            Intervals created:<br />
                            &nbsp;0 - &nbsp;6<br />
                            &nbsp;7 - 13<br />
                            14 - 20<br />
                            21 - 27<br />
                            ... and so on.
                        </div>
                    </template>
                    <template v-else-if="procedure === 'users'" class="col-12 mt-3">

                        <div class="col-3 mt-3">
                            <div class="field grid">
                                <div class="col-12 form-field">
                                    <UsersPicker @user-selected="onUserSelected" />
                                </div>
                                <div class="col-12 flex justify-content-between">
                                    <Button label="Add user" icon="pi pi-plus-circle" class="ml-2 p-button-success" :disabled="userSelectedData === null" @click="onAddSelectedUser"/>

                                    <div class="mt-2">
                                        Selected users: <b>{{ userSelectedList.length }}</b>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-9 my-3">
                            This procedure will return two groups:
                            <ol>
                                <li>The user(s) specified.</li>
                                <li>The rest of the world, if not filtered in the Datasource</li>
                            </ol>
                        </div>

                        <div class="col-6">
                            <DataTable
                                :value="userSelectedList"
                                :paginator="true"
                                :rows="5"
                                responsiveLayout="scroll"
                                :loading="loadingUsers"
                            >
                                <template #empty> No Users available </template>
                                <Column field="id" header="ID" />
                                <Column field="fullname" header="Full name" />
                                <Column field="actions" header="ACTIONS" style="min-width: 8rem">
                                    <template #body="slotProps">
                                        <Button icon="pi pi-times" class="p-button-rounded p-button-warning mr-2" @click="onRemoveSelectedUser(slotProps.data)" />
                                    </template>
                                </Column>
                            </DataTable>
                        </div>
                    </template>
                    <template v-else-if="procedure === 'calendar'" class="col-12 mt-3">
                        <div class="col-3 mt-3">
                            <div class="field grid">
                                <div class="col-12 form-field">
                                    <label for="first">Age range</label>
                                    <Dropdown id="first" v-model="first" :options="getCalendarUnitTypes()" placeholder="Select a time unit" optionLabel="name" optionValue="value" />
                                </div>
                                <div class="col-12 form-field">
                                    <label for="second">Age range</label>
                                    <InputText maxlength = "255" id="second" v-model="second" class="flex-auto" autocomplete="off"  placeholder="Enter the range"/>
                                </div>
                            </div>
                        </div>
                        <div class="col-9 my-3">
                            Please, select how long will be your grouping interval by selecting
                            <b>Years</b>, <b>Months</b>, <b>Weeks</b> or <b>Days</b> and specifying how many.<br />
                            Examples:<br />
                            <ul>
                                <li>5 Months</li>
                                <li>8 Years</li>
                                <li>3 Days</li>
                            </ul>
                        </div>
                    </template>
                    <template v-else-if="procedure === 'values'" class="col-12 mt-3">
                        <div class="col-6 mt-3 form-field">
                            <label for="tag_id">Tag: </label>
                            <Dropdown id="tag_id" v-model="tagValueConfig" :options="tags" filter optionLabel="description"
                                      optionValue="id" placeholder="Select a Tag" class="w-full md:w-14rem"
                                      :showClear="true" @change="onTagValue" />
                        </div>
                        <div class="col-6 mt-3 form-field">
                            <label for="attribute_code">Attribute Code</label>
                            <Dropdown  id="attribute_code" v-model="attributeValueConfig" :options="attributes" filter optionLabel="name"
                                       optionValue="code" placeholder="Select an attribute" class="w-full md:w-14rem"
                                       :showClear="true" @change="onAttributeValue" />
                            <div class="mt-5">
                                <h5>Please note</h5>
                                <p>
                                    Not every Attribute is suitable for grouping data. Only the following types will be used:
                                    <ol>
                                        <li>Radios</li>
                                        <li>Drop downs</li>
                                        <li>Checkboxes</li>
                                    </ol>
                                </p>
                            </div>
                        </div>
                    </template>

                    <div class="col-12 mt-3">
                        <div class="flex justify-content-end">
                            <Button label="Prev" icon="pi pi-arrow-circle-left" class="ml-2 p-button-success" @click="onPrev" />
                            <Button label="Cancel" icon="pi pi-times" class="ml-2 p-button-danger" @click="toggleVisibility" />
                            <Button label="Submit" icon="pi pi-check" class="ml-2 p-button-primary" :disabled="!multiStepFormIsValid" @click="onSubmit" />
                        </div>
                    </div>
                </div>
            </AccordionTab>
        </Accordion>

        <div class="grid" v-if="!multiStepConfig">

            <div class="col-12 mt-3">
                <div class="flex justify-content-end">
                    <Button label="Cancel" icon="pi pi-times" class="p-button-danger" @click="toggleVisibility" />
                    <Button label="Submit" icon="pi pi-check" class="ml-2 p-button-primary" @click="onSubmit" />
                </div>
            </div>
        </div>
    </Dialog>
</template>

<script setup>

import { computed, defineEmits, defineProps, ref, watch } from 'vue';
import { showToast } from '@/helpers/toast-handler';
import UsersPicker from '@/components/user/UsersPicker.vue';
import GlobalRequest from '@/api/global-request';
import store from '@/store';

const emit = defineEmits(['hideMetricGroupPopup', 'saveMetricGroupData']);

const visible = computed(() => props.display)
const group = computed(() => props.groupData)
const multiStepConfig = computed(() => {
    return multiStepProcedures.includes(procedure.value)
})

const configurationName = computed(() => {
    let procedureName = '';

    switch(procedure.value) {
        case 'age_today_range':
            procedureName = 'Today age range';
            break;
        case 'age_assessment_range':
            procedureName = 'Assessment date age range';
            break;
        default:
            procedureName = procedure.value.charAt(0).toUpperCase() + procedure.value.slice(1);
    }

    return 'Configuration of "'+procedureName+'"';
})

const props = defineProps({
    display: {
        type: Boolean,
        required: false,
        default: false
    },
    groupData: {
        type: Object,
        required: true
    },
    tags: {
        type: Array,
        default: () => {return []}
    },
    attributes: {
        type: Array,
        default: () => {return []}
    },
    sharable: {
        type: Number
    },
});

const multiStepProcedures = [
    'age_today_range',
    'age_assessment_range',
    'calendar',
    'users',
    'values',
];

const multiStepFormIsValid = computed(() => {

    switch (procedure.value) {
        case 'calendar':
            if (!first.value || first.value.length === 0) {
                return false
            }

            if (!second.value || second.value.length === 0 || isNaN(second.value)) {
                return false
            }

            break
        case 'age_today_range':
        case 'age_assessment_range':

            if (!first.value || first.value.length === 0 || isNaN(first.value)) {
                return false
            }

            break
        case 'users':

            if (!first.value || first.value.length === 0) {
                return false
            }

            if (!Array.isArray(JSON.parse(first.value)) || JSON.parse(first.value).length === 0) {
                return false
            }

            break
        case 'values':
            if (!first.value || typeof first.value === 'undefined' || first.value.length === 0) {
                return false
            }

            if (typeof first.value == 'object') {

                if (Object.hasOwn(first.value, 'tag_id')) {
                    if (!first.value.tag_id || first.value.tag_id.length === 0 || isNaN(first.value.tag_id)) {
                        return false
                    } else {
                        return true
                    }
                } else if (Object.hasOwn(first.value, 'attribute_code')) {
                    if (!first.value.attribute_code || first.value.attribute_code.length === 0) {
                        return false
                    } else {
                        return true
                    }
                } else {
                    return false
                }
            } else {
                return false
            }
    }

    return true
})

const activeIndex = ref(0);

const procedure = ref('')
const first = ref()
const second = ref('')
const groupId = ref(null)
const order = ref(0)

const tagValueConfig = ref(null)
const attributeValueConfig = ref(null)

const procedureChosen = computed(() => {
    return !(procedure.value === null || procedure.value.length === 0);
})

function onTagValue() {
    //console.log('~~~~~~~ onTagValue....')
    const tag = tagValueConfig.value
    attributeValueConfig.value = null;
    first.value = {
        tag_id: tag,
    }
}

function onAttributeValue() {
    //console.log('~~~~~~~ onAttributeValue....')
    const attribute = attributeValueConfig.value
    tagValueConfig.value = null
    first.value = {
        attribute_code: attribute,
    }
}

function onNoAdditionalParameters()
{
    first.value = '';
    second.value = '';
}

function onAgeTodayRange() {
    first.value = '10';
    second.value = '';
    procedure.value = 'age_today_range';
}

function onAgeAssessmentRange() {
    first.value = '10';
    second.value = '';
    procedure.value = 'age_assessment_range'
}

function onUser() {
    procedure.value = 'users';
    first.value = '';
    second.value = '';
    userSelectedData.value = null;
    userSelectedList.value = [];
}

function onCalendar() {
    procedure.value = 'calendar'
    first.value = '';
    second.value = '';
}

function getCalendarUnitTypes() {
    return [
        {
            name: 'Years',
            value: 'years',
        },
        {
            name: 'Months',
            value: 'months',
        },
        {
            name: 'Weeks',
            value: 'weeks',
        },
        {
            name: 'Days',
            value: 'days',
        },
    ];
}

const company_id = computed(() => {
    return store.getters['auth/userCompanyId']?.id;
});

const loadingUsers = ref(false)

watch(props, (newValue/*, oldValue*/) => {
    //console.log('~~~~~~~ watch')

    /**
     * Fetch data only when the popup became visible
     */
    if (newValue.display === true) {
        //console.log('props.groupData', props.groupData)
        procedure.value = props.groupData.procedure;
        first.value = props.groupData.first;
        second.value = props.groupData.second;
        groupId.value = props.groupData.id;
        order.value = props.groupData.order;

        if (procedure.value === 'values' && first.value !== null & first.value.length > 0) {

            const valueSetup = JSON.parse(first.value);

            //console.log(first.value, valueSetup)

            attributeValueConfig.value = tagValueConfig.value = null

            if (valueSetup !== null && Object.hasOwn(valueSetup, 'tag_id')) {
                tagValueConfig.value = valueSetup.tag_id
                onTagValue()
            } else if (valueSetup !== null && Object.hasOwn(valueSetup, 'attribute_code')) {
                attributeValueConfig.value = valueSetup.attribute_code
                onAttributeValue()
            }
        }

        if (procedure.value === 'users') {
            loadingUsers.value = true;
            const userIds = JSON.parse(first.value);

            userSelectedList.value = [];

            if (userIds && Array.isArray(userIds)) {
                userIds.forEach((selectedUserId) => {
                    GlobalRequest.getRequest('/v2/admin/users/'+selectedUserId+'?company_id=', {
                        params: {
                            company_id: company_id.value,
                        },
                    }).then((response) => {
                        if (response.statusCode === 200) {
                            userSelectedList.value.push({
                                id: response.data.id,
                                fullname: response.data.name + ' ' + response.data.surname,
                            })

                            // when all selected users are fetched, enable the table
                            if (userSelectedList.value.length === userIds.length) {
                                loadingUsers.value = false;
                            }
                        }
                    }).catch(async (error) => {
                        console.log('error', error);
                        loadingUsers.value = false;
                    });
                })
            }
        }

        activeIndex.value = 0;
    }
})

function onPrev() {
    activeIndex.value = 0;
}

function onNext() {
    activeIndex.value = 1;
}

const createUpdateGroup = computed( () => {
    if (group.value && group.value.id !== null) {
        return 'Edit of a group';
    } else {
        return 'Create a new group';
    }
});

function toggleVisibility(visible) {
    emit('hideMetricGroupPopup', visible)
}

function onSubmit() {
    //saveMetricGroupData

    if (!procedureChosen.value) {
        showToast({}, "Please select a procedure")
    } else {
        emit('saveMetricGroupData', {
            id: groupId.value,
            procedure: procedure.value,
            first: first.value,
            second: second.value,
            order: order.value,
        })
        toggleVisibility(false);
    }
}

const userSelectedData = ref(null);
const userSelectedList = ref([]);

function onUserSelected(userDetails) {
    userSelectedData.value = userDetails;
}

function onAddSelectedUser() {
    if (userSelectedData.value !== null) {

        let found = false;

        // Skip item already added to the list
        userSelectedList.value.forEach((item) => {
            if (item.id === userSelectedData.value.id) {
                found = true;
            }
        })

        if (!found) {
            userSelectedList.value.push({
                id: userSelectedData.value.id,
                fullname: userSelectedData.value.fullname,
            })

            let usersToSerialise = [];

            userSelectedList.value.forEach((item) => {
                usersToSerialise.push(item.id)
            })

            first.value = JSON.stringify(usersToSerialise);
        }
    }
}

function onRemoveSelectedUser(data) {
    let toRemove = null;
    userSelectedList.value.forEach((item, index) => {
        if (item.id === data.id) {
            toRemove = index;
        }
    })

    userSelectedList.value.splice(toRemove, 1);

    first.value = JSON.stringify(userSelectedList.value);
}

</script>

<style scoped>
.form-field {
    display: flex;
    flex-direction: column;
    margin-bottom: 1rem;
}

.form-field label {
    margin-bottom: 0.5rem;
}
</style>